import * as React from "react";
import { forwardRef } from "react";
const SvgLibrary = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 5H21V7H3V5ZM3 11H13V13H3V11ZM3 17H21V19H3V17Z", fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgLibrary);
export default ForwardRef;
